// eslint-disable
import {
  GET_USERS_DATA,
  DELETE_USER_DATA,
  GET_USERS_BY_GROUP_ID,
  GET_USERS_LIST_BY_GROUP_ID,
  UPDATE_FETCH_USERS_DATA_INPROGRESS,
  SESSION_SUCCESS,
  SESSION_ERROR,
  TOKEN_ACTIVATE_STATUS,
} from '../../../actions'

export const getUsersDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case GET_USERS_DATA:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_USERS_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getUsersByGroupIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USERS_BY_GROUP_ID:
      return { ...state, [action.groupId]: action.payload }

    default:
      return state
  }
}

export const getUsersListByGroupIdReducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case GET_USERS_LIST_BY_GROUP_ID:
      return { ...state, ['data']: action.payload }

    default:
      return state
  }
}

export const deleteUserDataReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_USER_DATA:
      return { ...state, [action.userId]: action.payload }

    default:
      return state
  }
}

export const getTokenActiveStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case TOKEN_ACTIVATE_STATUS:
      return { ...action.payload, isTokenActive: action.payload.isTokenActive }
    default:
      return state
  }
}

export const getsessionStatusReducer = (state = { error: true, errorMessage: '' }, action) => {
  switch (action.type) {
    case SESSION_SUCCESS:
      return { ...state, [action]: action.payload, error: false, errorMessage: action.payload }
    case SESSION_ERROR:
      return { ...state, error: true, errorMessage: action.payload }
    default:
      return state
  }
}
